const months = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

export function characteristicMonth(value) {
    const match = /^(\d{4})-(\d{2})/.exec(String(value || ''));
    return match && months[Number(match[2]) - 1] ? `${months[Number(match[2]) - 1]} ${match[1]}` : '';
}

export function characteristicDate(value) {
    const date = value && new Date(value);
    return date && !Number.isNaN(date.getTime())
        ? date.toLocaleString('ru-RU', {day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'}) : '';
}

export function characteristicValue(value) {
    return value === true ? 'Да' : value === false ? 'Нет'
        : value == null || value === '' ? 'Не заполнено' : String(value);
}

export function sameCharacteristicAuthor(a, b) {
    return Boolean(a && b && a.user_id && Number(a.user_id) === Number(b.user_id) && a.occurred_at === b.occurred_at);
}

export function describeCharacteristic(values, fields) {
    return fields.map(field => `${field.label}: ${characteristicValue((values || {})[field.key])}`).join('\n');
}
